import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiEnvironmentService } from '..//api-environment.service';
import { GeoLocationResponse } from './geo-location.model';

@Injectable()
export class GeoLocationService {
  constructor(
    private httpClient: HttpClient,
    private apiService: ApiEnvironmentService
  ) {}

  public getGeoLocation(text: string): Promise<GeoLocationResponse> {
    const apiBaseHref = this.apiService.getApiBaseHref();
    const url = encodeURI(`${apiBaseHref}/Geo/Geocode?text=${text}`);
    const headers = new HttpHeaders({
      Accept: '*/*'
    });

    return this.httpClient
      .get(url, { headers: headers })
      .toPromise()
      .then(response => {
        return response;
      })
      .catch(this.handleError);
  }

  private handleError(error: any): Promise<any> {
    console.error('Error getting name suggestions from a name suggestion service.');
    return Promise.reject(error.message || error);
  }
}
